import DateRangePicker from "./DateRangePickerComponent";

export default DateRangePicker;
